import axios from 'axios'
import type {
  FileTypeCreateRequest,
  FileTypePaginatedRequest,
  FileTypePaginatedResponse,
  FileTypePatchRequest,
  FileTypeResponse,
} from 'types'

export const fileTypeList = (request: FileTypePaginatedRequest) =>
  axios
    .get<FileTypePaginatedResponse>('/api/file-types', { params: request })
    .then((res) => res.data)

export const fileTypeGet = (uuid: string) =>
  axios.get<FileTypeResponse>(`/api/file-types/${uuid}`).then((res) => res.data)

export const fileTypeCreate = (request: FileTypeCreateRequest) =>
  axios
    .post<FileTypeResponse>('/api/file-types', request)
    .then((res) => res.data)

interface FileTypePatchPayload {
  uuid: string
  request: FileTypePatchRequest
}

export const fileTypePatch = ({ uuid, request }: FileTypePatchPayload) =>
  axios
    .patch<FileTypeResponse>(`/api/file-types/${uuid}`, request)
    .then((res) => res.data)

export const fileTypeArchive = (uuid: string) =>
  axios.post<void>(`/api/file-types/${uuid}/archived`).then((res) => res.data)
